import { useCallback, useEffect, useRef } from "react";
import { selectViewport } from "../../slices/UI.slice";
import { useAppSelector } from "../../store/hooks";
import CustomCard from "../CustomCard";
import { CustomCardWithMetricsFilterProps } from "../Interfaces/CustomCardWithMetricsFilter.interfaces";
import { customCardStyles } from "../Styles/CustomCardWithMetrics.styles";
import { MetricsHeader } from "./MetricsHeader";

export const CustomCardWithMetricsFilter = ({
  itemMemo,
  loading,
  metricFilters,
  onResetFilters,
  options,
  setMetricFilters,
  onCardWidthChange: setWidth
}: CustomCardWithMetricsFilterProps) => {
  const customCardContainerRef = useRef<HTMLDivElement>(null);
  const resizedWidth = useAppSelector((state) => selectViewport(state).offsetWidth);

  // Handlers
  const handleResize = useCallback((width: number) => setWidth?.(width), [setWidth]);
  const handleResetFilters = useCallback(() => {
    setMetricFilters({});
    onResetFilters?.();
  }, [setMetricFilters, onResetFilters]);

  // Hooks
  useEffect(() => {
    if (customCardContainerRef.current) {
      handleResize(customCardContainerRef.current.offsetWidth);
    }
  }, [resizedWidth, handleResize]);

  return itemMemo?.map(({ component, key, title }, index) => (
    <CustomCard
      key={key}
      cardHeaderTitle={
        <MetricsHeader
          title={title}
          isLoading={!!loading}
          metricFilters={metricFilters}
          onResetFilters={handleResetFilters}
        />
      }
      styles={customCardStyles}
      kustoLink={options?.chartOptions?.[index]?.kustoLink}
      isLoading={loading}
    >
      <div ref={customCardContainerRef}>{component()}</div>
    </CustomCard>
  ));
};
